import GarageDetails from './GarageDetails';

export default GarageDetails;
